import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { E as d, S as u } from "./icons.types-0722eef5.js";
function g({ title: s, titleId: n, size: l, width: r, height: e, extended: o = !1, ...t }) {
  const f = o ? d : u, c = l ? f[l] : r || f[o ? "s" : "l"], h = l ? f[l] : e || f[o ? "s" : "l"];
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: c,
      height: h,
      "aria-labelledby": n,
      ...t,
      children: [
        s ? /* @__PURE__ */ i("title", { id: n, children: s }) : null,
        /* @__PURE__ */ i(
          "path",
          {
            fill: "#EC1C24",
            d: "M68 47c0 6.075-3.373 11-10 11H14C7.373 58 4 53.075 4 47V25c0-6.075 3.373-11 10-11h44c6.627 0 10 4.925 10 11v22Z"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "#ffffff",
            fillRule: "evenodd",
            d: "M43.778 42.32c-2.302 3.591-7.095 5.856-12.11 4.391-4.733-1.386-7.984-5.972-7.715-10.918.262-4.968 3.994-9.193 8.844-10.05 5.139-.913 9.267 1.842 11.03 4.726-2.089-2.054-4.518-2.979-7.362-2.654-2.228.256-4.09 1.263-5.548 2.963-2.854 3.322-2.749 8.304.231 11.439 1.709 1.798 3.811 2.739 6.292 2.762 2.479.018 4.582-.92 6.344-2.654",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ i(
          "path",
          {
            fill: "#ffffff",
            d: "m48.23 32.396 2.03 1.884 2.708-.6-1.167 2.52 1.409 2.381-2.75-.331-1.839 2.08-.531-2.722-2.548-1.104 2.422-1.344.266-2.764Z"
          }
        )
      ]
    }
  );
}
export {
  g as TurTurkey
};
